import React from 'react';

import { matchPath, useHistory, useParams } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';


interface IDetailsBreadcrumbProps {
  defaultText: string;
  routes: string[]
}

export default function FileDetailsPageBreadcrumb({ defaultText, routes }: IDetailsBreadcrumbProps) {
  const history = useHistory();
  const { fileId } = useParams<{ fileId: string }>();

  const onClick = (event: any) => {
    event.preventDefault();
    const path = new URL(window.location.href).pathname;

    const isFileDetailsPage = matchPath(path, {
      path: routes,
      exact: true,
    });

    if (isFileDetailsPage) {
      window.location.reload();
    }
    else {
      const link = getParameterizedLink(`/variable-billing/${fileId}`);
      history.push(link);
    }
  };


  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {defaultText}
    </a>
  );
}
